import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import './Message.css'

class Message extends Component {
    constructor(props){
        super(props)
        console.log(props)
    }

    render() {
        return(
            <div className="container message">
                <label className="action">{this.props.message.action}</label>
                <br/>
                <label>{this.props.message.description}</label>
                <br/>
                <label>{new Date(this.props.message.date).toDateString().slice(3, 15)} ({this.props.message.userId.name})</label><label></label>
            </div>
        )
    }
}

export default Message


// WEBPACK FOOTER //
// ./src/components/Message/Mesaage.js